import * as React from "react"
import { useEffect } from "react"
import { Grid } from "@mui/material"

import { REPORTS_ROUTES } from "@constants"
import {isLoadingCommonFilters, isSystemBusy} from "@signals"
import ReportsPriceChangesDrawer from "./AlertDrawer"
import ReportsPriceChangesTable from "./AlertsTable"
import HistoricalModal from "./HistoricalModal"
import InfoModal from "./InfoModal"
import PageWrapper from "../../@PageWrapper"


export default function ReportsManagementPage() {

    const props = {
        head: `${REPORTS_ROUTES.TITLE} | Management`,
        title: REPORTS_ROUTES.MANAGE_TITLE,
        subtitle: REPORTS_ROUTES.MANAGE_SUBTITLE,
        actions: null,
        hasErrors: isSystemBusy.value
    }

    useEffect(() => {
       isLoadingCommonFilters.value = true
    }, [])

    useEffect(() => {
        return () => {
            isSystemBusy.value = false
            isLoadingCommonFilters.value = false
        }
     }, [])
    
    return <PageWrapper {...props}>
        <Grid container spacing={4}>
            <Grid item xs={12}>
                <ReportsPriceChangesTable />
            </Grid>
        </Grid>

        <ReportsPriceChangesDrawer />
        <HistoricalModal />
        <InfoModal />
    </PageWrapper>
}